import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import QualityMetricsPage from "@/pages/admin/QualityMetricsPage";

export const Route = createFileRoute("/_admin/admin/quality-metrics")({
  head: () => pageHead("Admin · Quality Metrics", "AKIVA admin · quality metrics portal.", "/admin/quality-metrics", true),
  component: QualityMetricsPage,
});
